import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { nameOnlySchema, NameData } from "../utils/validateNameSchema";

export const useNameValidation = (defaultValues?: Partial<NameData>) => {
  const {
    register,
    formState: { errors },
    trigger,
    watch,
    setValue,
  } = useForm<NameData>({
    resolver: zodResolver(nameOnlySchema),
    defaultValues,
    mode: "onChange",
  });

  return {
    register,
    errors,
    trigger,
    watch,
    setValue,
  };
};